export const CalculationTipCommission = (sum, percent, amount) => {
    let commisionPercent = percent / 100; 
    if (commisionPercent !== 1) {
        const wholeTipCommission = (sum * commisionPercent + amount) / (1 - commisionPercent);
        return wholeTipCommission;
    }
    return 0;
};

export const GetCommission = (paymentMethod, paymentProcessor, amount) => {
    console.log('here the are: ' + paymentMethod + ' ' + paymentProcessor + ' ' + amount + ' ');
    if (paymentMethod === 'Credit Card' && (paymentProcessor === 'banquest' || paymentProcessor === 'stripe')) {
        /* const commisionPercent = (parseFloat(amount) * 2.9) / 100;
        const wholeCommissionAmount = 0.3 + commisionPercent; */
        const wholeCommissionAmount = CalculationTipCommission(parseFloat(amount), 2.9, 0.3);
        return wholeCommissionAmount.toFixed(2);
    }
    if (paymentMethod === 'check' && paymentProcessor === 'banquest') {        
        return 2;
    }

    if (paymentMethod === 'donorFund' && paymentProcessor === 'banquest') {        
        /* const commisionPercent = (parseFloat(amount) * 2.9) / 100;
        const wholeCommissionAmount = 0.3 + commisionPercent; */
        const wholeCommissionAmount = CalculationTipCommission(parseFloat(amount), 2.9, 0.3);
        return wholeCommissionAmount.toFixed(2);
    }

    if (paymentMethod === 'donorFund') {     
        const wholeCommissionAmount = CalculationTipCommission(parseFloat(amount), 2.9, 0.3);
        return wholeCommissionAmount.toFixed(2);
    }

    if (paymentMethod === 'paypal') {        
       /*  const commisionPercent = (parseFloat(amount) * 4) / 100;
        const wholeCommissionAmount = 0.3 + commisionPercent;
        return wholeCommissionAmount.toFixed(2); */
        const wholeCommissionAmount = CalculationTipCommission(parseFloat(amount), 4, 0.3);
        return wholeCommissionAmount.toFixed(2);
    }
    return 888;
};

const floorNumber = (number) => {
    return Math.floor(number * 100) / 100;
};
